import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "message-thinking" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.icons, (icon, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            icon
              ? (_openBlock(), _createBlock(_component_Icon, {
                  key: 0,
                  file: $setup.loading_message,
                  width: "14px",
                  height: "14px"
                }, null, 8, ["file"]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1024)
      ]))
    }), 128))
  ]))
}